import { keyBy, map, union, isUndefined, omit, without } from 'lodash'
import { isExternalItemId } from '../../utils'

// Normalized the item and related owners we call it `normalizeption`
export const normalizeItem = item => ({
  ...item,
  posseduto_da: {
    byOwner: keyBy(item.posseduto_da, 'user.id'),
    owners: map(item.posseduto_da, 'user.id'),
  },
})

// Merge two normalized items
export const merge2Items = (cachedItem, newItem) => {
  if (!cachedItem) {
    return newItem
  }
  return {
    ...newItem,
    posseduto_da: {
      byOwner: {
        ...cachedItem.posseduto_da.byOwner,
        ...newItem.posseduto_da.byOwner,
      },
      owners: union(
        newItem.posseduto_da.owners,
        cachedItem.posseduto_da.owners
      ),
    },
  }
}

// Map items by id and merge "smart" \w given acc
export const itemsById = (items, acc = {}) =>
  items.reduce((r, i) => {
    const item = normalizeItem(i)
    return { ...r, [item.id]: merge2Items(r[item.id], item) }
  }, acc)

// Make the loved _id by joins owners
export const itemUId = item => {
  // When external no need to concat owners to make it unique
  if (isExternalItemId(item.id)) {
    return item.id
  }
  // No owner
  if (isUndefined(item.posseduto_da)) {
    return item.id
  }
  // Join owners and make it unique to React eye
  return item.id + '-' + item.posseduto_da.map(p => p.user.id).join(',')
}

// Shortcut for update item in state
export const updateItem = (state, id, updater) => {
  // Not related to item
  if (isUndefined(state.data[id])) {
    return state
  }
  return {
    ...state,
    data: {
      ...state.data,
      [id]: updater(state.data[id]),
    },
  }
}

// Shortcut for remove item in state
export const removeItem = (state, id) => {
  // Not related to item
  if (isUndefined(state.data[id])) {
    return state
  }
  return {
    ...state,
    data: omit(state.data, id),
    ids: without(state.ids, id),
  }
}

// Clear items cache
export const clearItemsCache = state => ({
  ...state,
  ids: null,
  data: {},
  pagination: {
    total: null,
    nextOffset: 0,
  },
  cache: {
    key: null,
  },
})

export const swapExternalItem = (state, item) => {
  // Invalid external id
  if (
    !(item.external_id &&
      isExternalItemId(item.external_id) &&
      !isExternalItemId(item.id))
  ) {
    return state
  }
  // External id not in state
  if (isUndefined(state.data[item.external_id])) {
    return state
  }
  // Actually do the swap
  return {
    ...state,
    data: {
      ...omit(state.data, item.external_id),
      [item.id]: item,
    },
    ids: state.ids.map(id => (id === item.external_id ? itemUId(item) : id)),
  }
}

export const removeOwnerFromItem = (item, owner) => ({
  ...item,
  posseduto_da: {
    byOwner: omit(item.posseduto_da.byOwner, owner),
    owners: without(item.posseduto_da.owners, owner),
  },
})



// WEBPACK FOOTER //
// ./src/reducers/items/utils.js